<h4 class="font-weight-bold py-3 mb-4">Certificate {{certificate.identifier}}</h4>
<!--<p>This page is an example of basic layout. For more options use <strong>Angular starter template generator</strong> in the docs.</p>-->
<!--<p><button class="btn btn-primary btn-lg">Button</button></p>-->
<div class="card mb-4">
  <h6 class="card-header">
    Certificate Details
  </h6>
  <div class="card-body">
    <form>
      <div class="form-row">
        <div class="form-group col-md-12" *ngIf="certificate.thumbnail">
          <div class="certificate-preview" [ngStyle]="certificatePreview()"></div>
          <p></p>
          <button class="btn btn-primary" (click)="download()" *ngIf="certificate.filename">Download PDF</button>
        </div>
        <div class="form-group col-md-4">
          <label class="form-label">Reference</label>
          <div class="input-group">
            <input name="identifier" type="text" class="form-control" placeholder="Reference" [ngModel]="certificate.identifier" disabled>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label class="form-label">Expiry Date</label>
          <input name="asd" type="text" class="form-control" placeholder="Reference" [ngModel]="certificate.expiryDate | date:'shortDate'" disabled>
        </div>
        <div class="form-group col-md-4">
          <label class="form-label">Issuer</label>
          <input name="issuer" type="text" class="form-control" placeholder="Reference" [ngModel]="certificate.issuer" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Description</label>
        <input name="description" type="text" class="form-control" placeholder="Description" [ngModel]="certificate.description" disabled>
      </div>
      <div class="form-group" *ngIf="certificate.isEligibleForApprovalBy(currentUser())">
        <button class="btn btn-success" [swal]="swalApprove" (confirm)="approve(certificate); successDialog.fire()">Approve</button>
        <button class="btn btn-danger" [swal]="swalReject" (confirm)="reject(certificate)">Reject</button>
      </div>
      <div class="form-group" *ngIf="!certificate.isEligibleForApprovalBy(currentUser())">
        <label class="form-label">Status</label>
        <span class="form-control cert" [ngClass]="certificate.cssStatus()">{{certificate.readableStatus()}}</span>
      </div>
    </form>
  </div>

  <swal #successDialog title="Approved!" message="The certificate has been approved." [swalOptions]="{icon: 'success', customClass: {confirmButton:'btn btn-lg btn-success'}}"></swal>

</div>

